import React from "react";
import { Header, Footer } from "layouts";


const MainLayout = (props) => {
	return (
		<>
			<Header />
			<main>{ props.children }</main>
			<Footer />
		</>
	);
};

export default MainLayout;
